export const locales = [
  {
    country_code: 'AF',
    locales: [
      { id: 'ps_AF', name: 'Pashto (Afghanistan)' },
      { id: 'fa_AF', name: 'Persian (Afghanistan)' },
      { id: 'uz_Arab_AF', name: 'Uzbek (Arabic, Afghanistan)' },
    ],
    default_locale: 'ps_AF',
  },
  {
    country_code: 'AL',
    locales: [{ id: 'sq_AL', name: 'Albanian (Albania)' }],
    default_locale: 'sq_AL',
  },
  {
    country_code: 'DZ',
    locales: [
      { id: 'ar_DZ', name: 'Arabic (Algeria)' },
      { id: 'kab_DZ', name: 'kab_DZ' },
    ],
    default_locale: 'ar_DZ',
  },
  {
    country_code: 'AS',
    locales: [{ id: 'en_AS', name: 'English (American Samoa)' }],
    default_locale: 'en_AS',
  },
  {
    country_code: 'AD',
    locales: [{ id: 'ca', name: 'Catalan' }],
    default_locale: 'ca',
  },
  {
    country_code: 'AO',
    locales: [{ id: 'pt', name: 'Portuguese' }],
    default_locale: 'pt',
  },
  {
    country_code: 'AI',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'AQ',
    locales: [{ id: 'en_US', name: 'English (United States)' }],
    default_locale: 'en_US',
  },
  {
    country_code: 'AG',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'AR',
    locales: [{ id: 'es_AR', name: 'Spanish (Argentina)' }],
    default_locale: 'es_AR',
  },
  {
    country_code: 'AM',
    locales: [{ id: 'hy_AM', name: 'Armenian (Armenia)' }],
    default_locale: 'hy_AM',
  },
  {
    country_code: 'AW',
    locales: [{ id: 'nl', name: 'Dutch' }],
    default_locale: 'nl',
  },
  {
    country_code: 'AU',
    locales: [{ id: 'en_AU', name: 'English (Australia)' }],
    default_locale: 'en_AU',
  },
  {
    country_code: 'AT',
    locales: [{ id: 'de_AT', name: 'German (Austria)' }],
    default_locale: 'de_AT',
  },
  {
    country_code: 'AZ',
    locales: [
      { id: 'az_Cyrl_AZ', name: 'Azerbaijani (Cyrillic, Azerbaijan)' },
      { id: 'az_Latn_AZ', name: 'Azerbaijani (Latin, Azerbaijan)' },
    ],
    default_locale: 'az_Cyrl_AZ',
  },
  {
    country_code: 'BS',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'BH',
    locales: [{ id: 'ar_BH', name: 'Arabic (Bahrain)' }],
    default_locale: 'ar_BH',
  },
  {
    country_code: 'BD',
    locales: [{ id: 'bn_BD', name: 'Bengali (Bangladesh)' }],
    default_locale: 'bn_BD',
  },
  {
    country_code: 'BB',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'BY',
    locales: [{ id: 'be_BY', name: 'Belarusian (Belarus)' }],
    default_locale: 'be_BY',
  },
  {
    country_code: 'BE',
    locales: [
      { id: 'nl_BE', name: 'Dutch (Belgium)' },
      { id: 'en_BE', name: 'English (Belgium)' },
      { id: 'fr_BE', name: 'French (Belgium)' },
      { id: 'de_BE', name: 'German (Belgium)' },
    ],
    default_locale: 'nl_BE',
  },
  {
    country_code: 'BZ',
    locales: [{ id: 'en_BZ', name: 'English (Belize)' }],
    default_locale: 'en_BZ',
  },
  {
    country_code: 'BJ',
    locales: [{ id: 'fr_BJ', name: 'French (Benin)' }],
    default_locale: 'fr_BJ',
  },
  {
    country_code: 'BM',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'BT',
    locales: [{ id: 'dz', name: 'Dzongkha' }],
    default_locale: 'dz',
  },
  {
    country_code: 'BO',
    locales: [{ id: 'es_BO', name: 'Spanish (Bolivia)' }],
    default_locale: 'es_BO',
  },
  {
    country_code: 'BQ',
    locales: [{ id: 'nl', name: 'Dutch' }],
    default_locale: 'nl',
  },
  {
    country_code: 'BA',
    locales: [
      { id: 'bs_BA', name: 'Bosnian (Bosnia & Herzegovina)' },
      {
        id: 'sr_Cyrl_BA',
        name: 'Serbian (Cyrillic, Bosnia & Herzegovina)',
      },
      { id: 'sr_Latn_BA', name: 'Serbian (Latin, Bosnia & Herzegovina)' },
    ],
    default_locale: 'bs_BA',
  },
  {
    country_code: 'BW',
    locales: [{ id: 'en_BW', name: 'English (Botswana)' }],
    default_locale: 'en_BW',
  },
  {
    country_code: 'BV',
    locales: [{ id: 'no', name: 'Norwegian' }],
    default_locale: 'no',
  },
  {
    country_code: 'BR',
    locales: [{ id: 'pt_BR', name: 'Portuguese (Brazil)' }],
    default_locale: 'pt_BR',
  },
  {
    country_code: 'IO',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'BN',
    locales: [{ id: 'ms_BN', name: 'Malay (Brunei)' }],
    default_locale: 'ms_BN',
  },
  {
    country_code: 'BG',
    locales: [{ id: 'bg_BG', name: 'Bulgarian (Bulgaria)' }],
    default_locale: 'bg_BG',
  },
  {
    country_code: 'BF',
    locales: [{ id: 'fr_BF', name: 'French (Burkina Faso)' }],
    default_locale: 'fr_BF',
  },
  {
    country_code: 'BI',
    locales: [{ id: 'fr_BI', name: 'French (Burundi)' }],
    default_locale: 'fr_BI',
  },
  {
    country_code: 'CV',
    locales: [{ id: 'kea_CV', name: 'kea_CV' }],
    default_locale: 'kea_CV',
  },
  {
    country_code: 'KH',
    locales: [{ id: 'km_KH', name: 'Khmer (Cambodia)' }],
    default_locale: 'km_KH',
  },
  {
    country_code: 'CM',
    locales: [{ id: 'fr_CM', name: 'French (Cameroon)' }],
    default_locale: 'fr_CM',
  },
  {
    country_code: 'CA',
    locales: [
      { id: 'en_CA', name: 'English (Canada)' },
      { id: 'fr_CA', name: 'French (Canada)' },
    ],
    default_locale: 'en_CA',
  },
  {
    country_code: 'KY',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'CF',
    locales: [
      { id: 'fr_CF', name: 'French (Central African Republic)' },
      { id: 'sg_CF', name: 'Sango (Central African Republic)' },
    ],
    default_locale: 'fr_CF',
  },
  {
    country_code: 'TD',
    locales: [{ id: 'fr_TD', name: 'French (Chad)' }],
    default_locale: 'fr_TD',
  },
  {
    country_code: 'CL',
    locales: [{ id: 'es_CL', name: 'Spanish (Chile)' }],
    default_locale: 'es_CL',
  },
  {
    country_code: 'CN',
    locales: [
      { id: 'zh_CN', name: 'Chinese (China)' },
      { id: 'zh_Hans_CN', name: 'Chinese (Simplified, China)' },
      { id: 'ii_CN', name: 'Sichuan Yi (China)' },
      { id: 'bo_CN', name: 'Tibetan (China)' },
    ],
    default_locale: 'zh_CN',
  },
  {
    country_code: 'CX',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'CC',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'CO',
    locales: [{ id: 'es_CO', name: 'Spanish (Colombia)' }],
    default_locale: 'es_CO',
  },
  {
    country_code: 'KM',
    locales: [{ id: 'fr_KM', name: 'French (Comoros)' }],
    default_locale: 'fr_KM',
  },
  {
    country_code: 'CD',
    locales: [{ id: 'fr_CD', name: 'French (Congo - Kinshasa)' }],
    default_locale: 'fr_CD',
  },
  {
    country_code: 'CG',
    locales: [{ id: 'fr_CG', name: 'French (Congo - Brazzaville)' }],
    default_locale: 'fr_CG',
  },
  {
    country_code: 'CK',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'CR',
    locales: [{ id: 'es_CR', name: 'Spanish (Costa Rica)' }],
    default_locale: 'es_CR',
  },
  {
    country_code: 'HR',
    locales: [{ id: 'hr_HR', name: 'Croatian (Croatia)' }],
    default_locale: 'hr_HR',
  },
  {
    country_code: 'CU',
    locales: [{ id: 'es', name: 'Spanish' }],
    default_locale: 'es',
  },
  {
    country_code: 'CW',
    locales: [{ id: 'nl', name: 'Dutch' }],
    default_locale: 'nl',
  },
  {
    country_code: 'CY',
    locales: [{ id: 'el_CY', name: 'Greek (Cyprus)' }],
    default_locale: 'el_CY',
  },
  {
    country_code: 'CZ',
    locales: [{ id: 'cs_CZ', name: 'Czech (Czech Republic)' }],
    default_locale: 'cs_CZ',
  },
  {
    country_code: 'CI',
    locales: [{ id: 'fr_CI', name: 'French (Côte d’Ivoire)' }],
    default_locale: 'fr_CI',
  },
  {
    country_code: 'DK',
    locales: [{ id: 'da_DK', name: 'Danish (Denmark)' }],
    default_locale: 'da_DK',
  },
  {
    country_code: 'DJ',
    locales: [
      { id: 'fr_DJ', name: 'French (Djibouti)' },
      { id: 'so_DJ', name: 'Somali (Djibouti)' },
    ],
    default_locale: 'fr_DJ',
  },
  {
    country_code: 'DM',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'DO',
    locales: [{ id: 'es_DO', name: 'Spanish (Dominican Republic)' }],
    default_locale: 'es_DO',
  },
  {
    country_code: 'EC',
    locales: [{ id: 'es_EC', name: 'Spanish (Ecuador)' }],
    default_locale: 'es_EC',
  },
  {
    country_code: 'EG',
    locales: [{ id: 'ar_EG', name: 'Arabic (Egypt)' }],
    default_locale: 'ar_EG',
  },
  {
    country_code: 'SV',
    locales: [{ id: 'es_SV', name: 'Spanish (El Salvador)' }],
    default_locale: 'es_SV',
  },
  {
    country_code: 'GQ',
    locales: [
      { id: 'fr_GQ', name: 'French (Equatorial Guinea)' },
      { id: 'es_GQ', name: 'Spanish (Equatorial Guinea)' },
    ],
    default_locale: 'fr_GQ',
  },
  {
    country_code: 'ER',
    locales: [{ id: 'ti_ER', name: 'Tigrinya (Eritrea)' }],
    default_locale: 'ti_ER',
  },
  {
    country_code: 'EE',
    locales: [{ id: 'et_EE', name: 'Estonian (Estonia)' }],
    default_locale: 'et_EE',
  },
  {
    country_code: 'SZ',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'ET',
    locales: [
      { id: 'am_ET', name: 'Amharic (Ethiopia)' },
      { id: 'om_ET', name: 'Oromo (Ethiopia)' },
      { id: 'so_ET', name: 'Somali (Ethiopia)' },
      { id: 'ti_ET', name: 'Tigrinya (Ethiopia)' },
    ],
    default_locale: 'am_ET',
  },
  {
    country_code: 'FK',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'FO',
    locales: [{ id: 'fo_FO', name: 'Faroese (Faroe Islands)' }],
    default_locale: 'fo_FO',
  },
  {
    country_code: 'FJ',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'FI',
    locales: [
      { id: 'fi_FI', name: 'Finnish (Finland)' },
      { id: 'sv_FI', name: 'Swedish (Finland)' },
    ],
    default_locale: 'fi_FI',
  },
  {
    country_code: 'FR',
    locales: [{ id: 'fr_FR', name: 'French (France)' }],
    default_locale: 'fr_FR',
  },
  {
    country_code: 'GF',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'PF',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'TF',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'GA',
    locales: [{ id: 'fr_GA', name: 'French (Gabon)' }],
    default_locale: 'fr_GA',
  },
  {
    country_code: 'GM',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'GE',
    locales: [{ id: 'ka_GE', name: 'Georgian (Georgia)' }],
    default_locale: 'ka_GE',
  },
  {
    country_code: 'DE',
    locales: [{ id: 'de_DE', name: 'German (Germany)' }],
    default_locale: 'de_DE',
  },
  {
    country_code: 'GH',
    locales: [
      { id: 'ak_GH', name: 'Akan (Ghana)' },
      { id: 'ee_GH', name: 'Ewe (Ghana)' },
      { id: 'ha_Latn_GH', name: 'Hausa (Latin, Ghana)' },
    ],
    default_locale: 'ak_GH',
  },
  {
    country_code: 'GI',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'GR',
    locales: [{ id: 'el_GR', name: 'Greek (Greece)' }],
    default_locale: 'el_GR',
  },
  {
    country_code: 'GL',
    locales: [{ id: 'kl_GL', name: 'Kalaallisut (Greenland)' }],
    default_locale: 'kl_GL',
  },
  {
    country_code: 'GD',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'GP',
    locales: [{ id: 'fr_GP', name: 'French (Guadeloupe)' }],
    default_locale: 'fr_GP',
  },
  {
    country_code: 'GU',
    locales: [{ id: 'en_GU', name: 'English (Guam)' }],
    default_locale: 'en_GU',
  },
  {
    country_code: 'GT',
    locales: [{ id: 'es_GT', name: 'Spanish (Guatemala)' }],
    default_locale: 'es_GT',
  },
  {
    country_code: 'GG',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'GN',
    locales: [{ id: 'fr_GN', name: 'French (Guinea)' }],
    default_locale: 'fr_GN',
  },
  {
    country_code: 'GW',
    locales: [{ id: 'pt_GW', name: 'Portuguese (Guinea-Bissau)' }],
    default_locale: 'pt_GW',
  },
  {
    country_code: 'GY',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'HT',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'HM',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'VA',
    locales: [{ id: 'it', name: 'Italian' }],
    default_locale: 'it',
  },
  {
    country_code: 'HN',
    locales: [{ id: 'es_HN', name: 'Spanish (Honduras)' }],
    default_locale: 'es_HN',
  },
  {
    country_code: 'HK',
    locales: [
      { id: 'yue_Hant_HK', name: 'yue_Hant_HK' },
      {
        id: 'zh_Hans_HK',
        name: 'Chinese (Simplified, Hong Kong SAR China)',
      },
      {
        id: 'zh_Hant_HK',
        name: 'Chinese (Traditional, Hong Kong SAR China)',
      },
      { id: 'en_HK', name: 'English (Hong Kong SAR China)' },
    ],
    default_locale: 'en_HK',
  },
  {
    country_code: 'HU',
    locales: [{ id: 'hu_HU', name: 'Hungarian (Hungary)' }],
    default_locale: 'hu_HU',
  },
  {
    country_code: 'IS',
    locales: [{ id: 'is_IS', name: 'Icelandic (Iceland)' }],
    default_locale: 'is_IS',
  },
  {
    country_code: 'IN',
    locales: [
      { id: 'as_IN', name: 'Assamese (India)' },
      { id: 'bn_IN', name: 'Bengali (India)' },
      { id: 'en_IN', name: 'English (India)' },
      { id: 'gu_IN', name: 'Gujarati (India)' },
      { id: 'hi_IN', name: 'Hindi (India)' },
      { id: 'kn_IN', name: 'Kannada (India)' },
      { id: 'kok_IN', name: 'kok_IN' },
      { id: 'ml_IN', name: 'Malayalam (India)' },
      { id: 'mr_IN', name: 'Marathi (India)' },
      { id: 'ne_IN', name: 'Nepali (India)' },
      { id: 'or_IN', name: 'Oriya (India)' },
      { id: 'pa_Guru_IN', name: 'Punjabi (Gurmukhi, India)' },
      { id: 'ta_IN', name: 'Tamil (India)' },
      { id: 'te_IN', name: 'Telugu (India)' },
      { id: 'bo_IN', name: 'Tibetan (India)' },
      { id: 'ur_IN', name: 'Urdu (India)' },
    ],
    default_locale: 'hi_IN',
  },
  {
    country_code: 'ID',
    locales: [{ id: 'id_ID', name: 'Indonesian (Indonesia)' }],
    default_locale: 'id_ID',
  },
  {
    country_code: 'IR',
    locales: [{ id: 'fa_IR', name: 'Persian (Iran)' }],
    default_locale: 'fa_IR',
  },
  {
    country_code: 'IQ',
    locales: [{ id: 'ar_IQ', name: 'Arabic (Iraq)' }],
    default_locale: 'ar_IQ',
  },
  {
    country_code: 'IE',
    locales: [
      { id: 'en_IE', name: 'English (Ireland)' },
      { id: 'ga_IE', name: 'Irish (Ireland)' },
    ],
    default_locale: 'en_IE',
  },
  {
    country_code: 'IM',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'IL',
    locales: [
      { id: 'en_IL', name: 'en_IL' },
      { id: 'he_IL', name: 'Hebrew (Israel)' },
    ],
    default_locale: 'he_IL',
  },
  {
    country_code: 'IT',
    locales: [{ id: 'it_IT', name: 'Italian (Italy)' }],
    default_locale: 'it_IT',
  },
  {
    country_code: 'JM',
    locales: [{ id: 'en_JM', name: 'English (Jamaica)' }],
    default_locale: 'en_JM',
  },
  {
    country_code: 'JP',
    locales: [{ id: 'ja_JP', name: 'Japanese (Japan)' }],
    default_locale: 'ja_JP',
  },
  {
    country_code: 'JE',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'JO',
    locales: [{ id: 'ar_JO', name: 'Arabic (Jordan)' }],
    default_locale: 'ar_JO',
  },
  {
    country_code: 'KZ',
    locales: [{ id: 'kk_Cyrl_KZ', name: 'Kazakh (Cyrillic, Kazakhstan)' }],
    default_locale: 'kk_Cyrl_KZ',
  },
  {
    country_code: 'KE',
    locales: [
      { id: 'ebu_KE', name: 'ebu_KE' },
      { id: 'guz_KE', name: 'guz_KE' },
      { id: 'kln_KE', name: 'kln_KE' },
      { id: 'kam_KE', name: 'kam_KE' },
      { id: 'ki_KE', name: 'Kikuyu (Kenya)' },
      { id: 'luo_KE', name: 'luo_KE' },
      { id: 'luy_KE', name: 'luy_KE' },
      { id: 'mas_KE', name: 'mas_KE' },
      { id: 'mer_KE', name: 'mer_KE' },
      { id: 'om_KE', name: 'Oromo (Kenya)' },
      { id: 'saq_KE', name: 'saq_KE' },
      { id: 'so_KE', name: 'Somali (Kenya)' },
      { id: 'sw_KE', name: 'Swahili (Kenya)' },
      { id: 'dav_KE', name: 'dav_KE' },
      { id: 'teo_KE', name: 'teo_KE' },
    ],
    default_locale: 'ebu_KE',
  },
  {
    country_code: 'KI',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'KP',
    locales: [{ id: 'ko', name: 'Korean' }],
    default_locale: 'ko',
  },
  {
    country_code: 'KR',
    locales: [{ id: 'ko_KR', name: 'Korean (South Korea)' }],
    default_locale: 'ko_KR',
  },
  {
    country_code: 'KW',
    locales: [{ id: 'ar_KW', name: 'Arabic (Kuwait)' }],
    default_locale: 'ar_KW',
  },
  {
    country_code: 'KG',
    locales: [{ id: 'ky', name: 'Kyrgyz' }],
    default_locale: 'ky',
  },
  {
    country_code: 'LA',
    locales: [{ id: 'lo', name: 'Lao' }],
    default_locale: 'lo',
  },
  {
    country_code: 'LV',
    locales: [{ id: 'lv_LV', name: 'Latvian (Latvia)' }],
    default_locale: 'lv_LV',
  },
  {
    country_code: 'LB',
    locales: [{ id: 'ar_LB', name: 'Arabic (Lebanon)' }],
    default_locale: 'ar_LB',
  },
  {
    country_code: 'LS',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'LR',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'LY',
    locales: [{ id: 'ar_LY', name: 'Arabic (Libya)' }],
    default_locale: 'ar_LY',
  },
  {
    country_code: 'LI',
    locales: [{ id: 'de_LI', name: 'German (Liechtenstein)' }],
    default_locale: 'de_LI',
  },
  {
    country_code: 'LT',
    locales: [{ id: 'lt_LT', name: 'Lithuanian (Lithuania)' }],
    default_locale: 'lt_LT',
  },
  {
    country_code: 'LU',
    locales: [
      { id: 'fr_LU', name: 'French (Luxembourg)' },
      { id: 'de_LU', name: 'German (Luxembourg)' },
    ],
    default_locale: 'fr_LU',
  },
  {
    country_code: 'MO',
    locales: [
      { id: 'zh_Hans_MO', name: 'Chinese (Simplified, Macau SAR China)' },
      { id: 'zh_Hant_MO', name: 'Chinese (Traditional, Macau SAR China)' },
    ],
    default_locale: 'zh_Hans_MO',
  },
  {
    country_code: 'MG',
    locales: [
      { id: 'fr_MG', name: 'French (Madagascar)' },
      { id: 'mg_MG', name: 'Malagasy (Madagascar)' },
    ],
    default_locale: 'fr_MG',
  },
  {
    country_code: 'MW',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'MY',
    locales: [{ id: 'ms_MY', name: 'Malay (Malaysia)' }],
    default_locale: 'ms_MY',
  },
  {
    country_code: 'MV',
    locales: [{ id: 'dv', name: 'dv' }],
    default_locale: 'dv',
  },
  {
    country_code: 'ML',
    locales: [
      { id: 'bm_ML', name: 'bm_ML' },
      { id: 'fr_ML', name: 'French (Mali)' },
      { id: 'khq_ML', name: 'khq_ML' },
      { id: 'ses_ML', name: 'ses_ML' },
    ],
    default_locale: 'fr_ML',
  },
  {
    country_code: 'MT',
    locales: [
      { id: 'en_MT', name: 'English (Malta)' },
      { id: 'mt_MT', name: 'Maltese (Malta)' },
    ],
    default_locale: 'en_MT',
  },
  {
    country_code: 'MH',
    locales: [{ id: 'en_MH', name: 'English (Marshall Islands)' }],
    default_locale: 'en_MH',
  },
  {
    country_code: 'MQ',
    locales: [{ id: 'fr_MQ', name: 'French (Martinique)' }],
    default_locale: 'fr_MQ',
  },
  {
    country_code: 'MR',
    locales: [{ id: 'ar', name: 'Arabic' }],
    default_locale: 'ar',
  },
  {
    country_code: 'MU',
    locales: [
      { id: 'en_MU', name: 'English (Mauritius)' },
      { id: 'mfe_MU', name: 'mfe_MU' },
    ],
    default_locale: 'en_MU',
  },
  {
    country_code: 'YT',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'MX',
    locales: [{ id: 'es_MX', name: 'Spanish (Mexico)' }],
    default_locale: 'es_MX',
  },
  {
    country_code: 'FM',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'MD',
    locales: [
      { id: 'ro_MD', name: 'Romanian (Moldova)' },
      { id: 'ru_MD', name: 'Russian (Moldova)' },
    ],
    default_locale: 'ro_MD',
  },
  {
    country_code: 'MC',
    locales: [{ id: 'fr_MC', name: 'French (Monaco)' }],
    default_locale: 'fr_MC',
  },
  {
    country_code: 'MN',
    locales: [{ id: 'mn', name: 'Mongolian' }],
    default_locale: 'mn',
  },
  {
    country_code: 'ME',
    locales: [
      { id: 'sr_Cyrl_ME', name: 'Serbian (Cyrillic, Montenegro)' },
      { id: 'sr_Latn_ME', name: 'Serbian (Latin, Montenegro)' },
    ],
    default_locale: 'sr_Cyrl_ME',
  },
  {
    country_code: 'MS',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'MA',
    locales: [
      { id: 'ar_MA', name: 'Arabic (Morocco)' },
      { id: 'tzm_Latn_MA', name: 'tzm_Latn_MA' },
      { id: 'shi_Latn_MA', name: 'shi_Latn_MA' },
      { id: 'shi_Tfng_MA', name: 'shi_Tfng_MA' },
    ],
    default_locale: 'ar_MA',
  },
  {
    country_code: 'MZ',
    locales: [
      { id: 'pt_MZ', name: 'Portuguese (Mozambique)' },
      { id: 'seh_MZ', name: 'seh_MZ' },
    ],
    default_locale: 'pt_MZ',
  },
  {
    country_code: 'MM',
    locales: [{ id: 'my_MM', name: 'Burmese (Myanmar (Burma))' }],
    default_locale: 'my_MM',
  },
  {
    country_code: 'NA',
    locales: [
      { id: 'af_NA', name: 'Afrikaans (Namibia)' },
      { id: 'en_NA', name: 'English (Namibia)' },
      { id: 'naq_NA', name: 'naq_NA' },
    ],
    default_locale: 'en_NA',
  },
  {
    country_code: 'NR',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'NP',
    locales: [{ id: 'ne_NP', name: 'Nepali (Nepal)' }],
    default_locale: 'ne_NP',
  },
  {
    country_code: 'NL',
    locales: [{ id: 'nl_NL', name: 'Dutch (Netherlands)' }],
    default_locale: 'nl_NL',
  },
  {
    country_code: 'AN',
    locales: [{ id: 'nl_AN', name: 'nl_AN' }],
    default_locale: 'nl_AN',
  },
  {
    country_code: 'NC',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'NZ',
    locales: [{ id: 'en_NZ', name: 'English (New Zealand)' }],
    default_locale: 'en_NZ',
  },
  {
    country_code: 'NI',
    locales: [{ id: 'es_NI', name: 'Spanish (Nicaragua)' }],
    default_locale: 'es_NI',
  },
  {
    country_code: 'NE',
    locales: [
      { id: 'fr_NE', name: 'French (Niger)' },
      { id: 'ha_Latn_NE', name: 'Hausa (Latin, Niger)' },
    ],
    default_locale: 'fr_NE',
  },
  {
    country_code: 'NG',
    locales: [
      { id: 'ha_Latn_NG', name: 'Hausa (Latin, Nigeria)' },
      { id: 'ig_NG', name: 'Igbo (Nigeria)' },
      { id: 'yo_NG', name: 'Yoruba (Nigeria)' },
    ],
    default_locale: 'ha_Latn_NG',
  },
  {
    country_code: 'NU',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'NF',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'MK',
    locales: [{ id: 'mk_MK', name: 'Macedonian (Macedonia)' }],
    default_locale: 'mk_MK',
  },
  {
    country_code: 'MP',
    locales: [{ id: 'en_MP', name: 'English (Northern Mariana Islands)' }],
    default_locale: 'en_MP',
  },
  {
    country_code: 'NO',
    locales: [
      { id: 'nb_NO', name: 'Norwegian Bokmål (Norway)' },
      { id: 'nn_NO', name: 'Norwegian Nynorsk (Norway)' },
    ],
    default_locale: 'nb_NO',
  },
  {
    country_code: 'OM',
    locales: [{ id: 'ar_OM', name: 'Arabic (Oman)' }],
    default_locale: 'ar_OM',
  },
  {
    country_code: 'PK',
    locales: [
      { id: 'en_PK', name: 'English (Pakistan)' },
      { id: 'pa_Arab_PK', name: 'Punjabi (Arabic, Pakistan)' },
      { id: 'ur_PK', name: 'Urdu (Pakistan)' },
    ],
    default_locale: 'en_PK',
  },
  {
    country_code: 'PW',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'PS',
    locales: [{ id: 'ar', name: 'Arabic' }],
    default_locale: 'ar',
  },
  {
    country_code: 'PA',
    locales: [{ id: 'es_PA', name: 'Spanish (Panama)' }],
    default_locale: 'es_PA',
  },
  {
    country_code: 'PG',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'PY',
    locales: [{ id: 'es_PY', name: 'Spanish (Paraguay)' }],
    default_locale: 'es_PY',
  },
  {
    country_code: 'PE',
    locales: [{ id: 'es_PE', name: 'Spanish (Peru)' }],
    default_locale: 'es_PE',
  },
  {
    country_code: 'PH',
    locales: [
      { id: 'en_PH', name: 'English (Philippines)' },
      { id: 'fil_PH', name: 'fil_PH' },
    ],
    default_locale: 'en_PH',
  },
  {
    country_code: 'PN',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'PL',
    locales: [{ id: 'pl_PL', name: 'Polish (Poland)' }],
    default_locale: 'pl_PL',
  },
  {
    country_code: 'PT',
    locales: [{ id: 'pt_PT', name: 'Portuguese (Portugal)' }],
    default_locale: 'pt_PT',
  },
  {
    country_code: 'PR',
    locales: [{ id: 'es_PR', name: 'Spanish (Puerto Rico)' }],
    default_locale: 'es_PR',
  },
  {
    country_code: 'QA',
    locales: [{ id: 'ar_QA', name: 'Arabic (Qatar)' }],
    default_locale: 'ar_QA',
  },
  {
    country_code: 'RO',
    locales: [{ id: 'ro_RO', name: 'Romanian (Romania)' }],
    default_locale: 'ro_RO',
  },
  {
    country_code: 'RU',
    locales: [{ id: 'ru_RU', name: 'Russian (Russia)' }],
    default_locale: 'ru_RU',
  },
  {
    country_code: 'RW',
    locales: [
      { id: 'fr_RW', name: 'French (Rwanda)' },
      { id: 'rw_RW', name: 'Kinyarwanda (Rwanda)' },
    ],
    default_locale: 'fr_RW',
  },
  {
    country_code: 'RE',
    locales: [{ id: 'fr_RE', name: 'French (Réunion)' }],
    default_locale: 'fr_RE',
  },
  {
    country_code: 'BL',
    locales: [{ id: 'fr_BL', name: 'French (St. Barthélemy)' }],
    default_locale: 'fr_BL',
  },
  {
    country_code: 'SH',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'KN',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'LC',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'MF',
    locales: [{ id: 'fr_MF', name: 'French (St. Martin)' }],
    default_locale: 'fr_MF',
  },
  {
    country_code: 'PM',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'VC',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'WS',
    locales: [{ id: 'sm', name: 'sm' }],
    default_locale: 'sm',
  },
  {
    country_code: 'SM',
    locales: [{ id: 'it', name: 'Italian' }],
    default_locale: 'it',
  },
  {
    country_code: 'ST',
    locales: [{ id: 'pt', name: 'Portuguese' }],
    default_locale: 'pt',
  },
  {
    country_code: 'SA',
    locales: [{ id: 'ar_SA', name: 'Arabic (Saudi Arabia)' }],
    default_locale: 'ar_SA',
  },
  {
    country_code: 'SN',
    locales: [
      { id: 'fr_SN', name: 'French (Senegal)' },
      { id: 'ff_SN', name: 'Fulah (Senegal)' },
    ],
    default_locale: 'fr_SN',
  },
  {
    country_code: 'RS',
    locales: [
      { id: 'sr_Cyrl_RS', name: 'Serbian (Cyrillic, Serbia)' },
      { id: 'sr_Latn_RS', name: 'Serbian (Latin, Serbia)' },
    ],
    default_locale: 'sr_Cyrl_RS',
  },
  {
    country_code: 'SC',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'SL',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'SG',
    locales: [
      { id: 'zh_Hans_SG', name: 'Chinese (Simplified, Singapore)' },
      { id: 'en_SG', name: 'English (Singapore)' },
    ],
    default_locale: 'en_SG',
  },
  {
    country_code: 'SX',
    locales: [{ id: 'nl', name: 'Dutch' }],
    default_locale: 'nl',
  },
  {
    country_code: 'SK',
    locales: [{ id: 'sk_SK', name: 'Slovak (Slovakia)' }],
    default_locale: 'sk_SK',
  },
  {
    country_code: 'SI',
    locales: [{ id: 'sl_SI', name: 'Slovenian (Slovenia)' }],
    default_locale: 'sl_SI',
  },
  {
    country_code: 'SB',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'SO',
    locales: [{ id: 'so_SO', name: 'Somali (Somalia)' }],
    default_locale: 'so_SO',
  },
  {
    country_code: 'ZA',
    locales: [
      { id: 'af_ZA', name: 'Afrikaans (South Africa)' },
      { id: 'en_ZA', name: 'English (South Africa)' },
      { id: 'zu_ZA', name: 'Zulu (South Africa)' },
    ],
    default_locale: 'af_ZA',
  },
  {
    country_code: 'GS',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'SS',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'ES',
    locales: [
      { id: 'eu_ES', name: 'Basque (Spain)' },
      { id: 'ca_ES', name: 'Catalan (Spain)' },
      { id: 'gl_ES', name: 'Galician (Spain)' },
      { id: 'es_ES', name: 'Spanish (Spain)' },
    ],
    default_locale: 'es_ES',
  },
  {
    country_code: 'LK',
    locales: [
      { id: 'si_LK', name: 'Sinhala (Sri Lanka)' },
      { id: 'ta_LK', name: 'Tamil (Sri Lanka)' },
    ],
    default_locale: 'si_LK',
  },
  {
    country_code: 'SD',
    locales: [{ id: 'ar_SD', name: 'Arabic (Sudan)' }],
    default_locale: 'ar_SD',
  },
  {
    country_code: 'SR',
    locales: [{ id: 'nl', name: 'Dutch' }],
    default_locale: 'nl',
  },
  {
    country_code: 'SJ',
    locales: [{ id: 'no', name: 'Norwegian' }],
    default_locale: 'no',
  },
  {
    country_code: 'SE',
    locales: [{ id: 'sv_SE', name: 'Swedish (Sweden)' }],
    default_locale: 'sv_SE',
  },
  {
    country_code: 'CH',
    locales: [
      { id: 'fr_CH', name: 'French (Switzerland)' },
      { id: 'de_CH', name: 'German (Switzerland)' },
      { id: 'it_CH', name: 'Italian (Switzerland)' },
      { id: 'rm_CH', name: 'Romansh (Switzerland)' },
      { id: 'gsw_CH', name: 'gsw_CH' },
    ],
    default_locale: 'fr_CH',
  },
  {
    country_code: 'SY',
    locales: [{ id: 'ar_SY', name: 'Arabic (Syria)' }],
    default_locale: 'ar_SY',
  },
  {
    country_code: 'TW',
    locales: [{ id: 'zh_Hant_TW', name: 'Chinese (Traditional, Taiwan)' }],
    default_locale: 'zh_Hant_TW',
  },
  {
    country_code: 'TJ',
    locales: [{ id: 'tg', name: 'tg' }],
    default_locale: 'tg',
  },
  {
    country_code: 'TZ',
    locales: [
      { id: 'asa_TZ', name: 'asa_TZ' },
      { id: 'bez_TZ', name: 'bez_TZ' },
      { id: 'lag_TZ', name: 'lag_TZ' },
      { id: 'jmc_TZ', name: 'jmc_TZ' },
      { id: 'kde_TZ', name: 'kde_TZ' },
      { id: 'mas_TZ', name: 'mas_TZ' },
      { id: 'rof_TZ', name: 'rof_TZ' },
      { id: 'rwk_TZ', name: 'rwk_TZ' },
      { id: 'sw_TZ', name: 'Swahili (Tanzania)' },
      { id: 'vun_TZ', name: 'vun_TZ' },
    ],
    default_locale: 'asa_TZ',
  },
  {
    country_code: 'TH',
    locales: [{ id: 'th_TH', name: 'Thai (Thailand)' }],
    default_locale: 'th_TH',
  },
  {
    country_code: 'TL',
    locales: [{ id: 'pt', name: 'Portuguese' }],
    default_locale: 'pt',
  },
  {
    country_code: 'TG',
    locales: [
      { id: 'ee_TG', name: 'Ewe (Togo)' },
      { id: 'fr_TG', name: 'French (Togo)' },
    ],
    default_locale: 'fr_TG',
  },
  {
    country_code: 'TK',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'TO',
    locales: [{ id: 'to_TO', name: 'Tongan (Tonga)' }],
    default_locale: 'to_TO',
  },
  {
    country_code: 'TT',
    locales: [{ id: 'en_TT', name: 'English (Trinidad & Tobago)' }],
    default_locale: 'en_TT',
  },
  {
    country_code: 'TN',
    locales: [{ id: 'ar_TN', name: 'Arabic (Tunisia)' }],
    default_locale: 'ar_TN',
  },
  {
    country_code: 'TR',
    locales: [{ id: 'tr_TR', name: 'Turkish (Turkey)' }],
    default_locale: 'tr_TR',
  },
  {
    country_code: 'TM',
    locales: [{ id: 'tk', name: 'tk' }],
    default_locale: 'tk',
  },
  {
    country_code: 'TC',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'TV',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'UG',
    locales: [
      { id: 'cgg_UG', name: 'cgg_UG' },
      { id: 'lg_UG', name: 'Ganda (Uganda)' },
      { id: 'nyn_UG', name: 'nyn_UG' },
      { id: 'xog_UG', name: 'xog_UG' },
      { id: 'teo_UG', name: 'teo_UG' },
    ],
    default_locale: 'cgg_UG',
  },
  {
    country_code: 'UA',
    locales: [
      { id: 'ru_UA', name: 'Russian (Ukraine)' },
      { id: 'uk_UA', name: 'Ukrainian (Ukraine)' },
    ],
    default_locale: 'uk_UA',
  },
  {
    country_code: 'AE',
    locales: [{ id: 'ar_AE', name: 'Arabic (United Arab Emirates)' }],
    default_locale: 'ar_AE',
  },
  {
    country_code: 'GB',
    locales: [
      { id: 'kw_GB', name: 'Cornish (United Kingdom)' },
      { id: 'en_GB', name: 'English (United Kingdom)' },
      { id: 'gv_GB', name: 'gv_GB' },
      { id: 'cy_GB', name: 'Welsh (United Kingdom)' },
    ],
    default_locale: 'en_GB',
  },
  {
    country_code: 'UM',
    locales: [{ id: 'en_UM', name: 'English (U.S. Outlying Islands)' }],
    default_locale: 'en_UM',
  },
  {
    country_code: 'US',
    locales: [
      { id: 'chr_US', name: 'chr_US' },
      { id: 'en_US', name: 'English (United States)' },
      { id: 'haw_US', name: 'haw_US' },
      { id: 'es_US', name: 'Spanish (United States)' },
    ],
    default_locale: 'en_US',
  },
  {
    country_code: 'UY',
    locales: [{ id: 'es_UY', name: 'Spanish (Uruguay)' }],
    default_locale: 'es_UY',
  },
  {
    country_code: 'UZ',
    locales: [
      { id: 'uz_Cyrl_UZ', name: 'Uzbek (Cyrillic, Uzbekistan)' },
      { id: 'uz_Latn_UZ', name: 'Uzbek (Latin, Uzbekistan)' },
    ],
    default_locale: 'uz_Cyrl_UZ',
  },
  {
    country_code: 'VU',
    locales: [{ id: 'bi', name: 'bi' }],
    default_locale: 'bi',
  },
  {
    country_code: 'VE',
    locales: [{ id: 'es_VE', name: 'Spanish (Venezuela)' }],
    default_locale: 'es_VE',
  },
  {
    country_code: 'VN',
    locales: [{ id: 'vi_VN', name: 'Vietnamese (Vietnam)' }],
    default_locale: 'vi_VN',
  },
  {
    country_code: 'VG',
    locales: [{ id: 'en', name: 'English' }],
    default_locale: 'en',
  },
  {
    country_code: 'VI',
    locales: [{ id: 'en_VI', name: 'English (U.S. Virgin Islands)' }],
    default_locale: 'en_VI',
  },
  {
    country_code: 'WF',
    locales: [{ id: 'fr', name: 'French' }],
    default_locale: 'fr',
  },
  {
    country_code: 'EH',
    locales: [{ id: 'es', name: 'Spanish' }],
    default_locale: 'es',
  },
  {
    country_code: 'YE',
    locales: [{ id: 'ar_YE', name: 'Arabic (Yemen)' }],
    default_locale: 'ar_YE',
  },
  {
    country_code: 'ZM',
    locales: [{ id: 'bem_ZM', name: 'bem_ZM' }],
    default_locale: 'bem_ZM',
  },
  {
    country_code: 'ZW',
    locales: [
      { id: 'en_ZW', name: 'English (Zimbabwe)' },
      { id: 'nd_ZW', name: 'North Ndebele (Zimbabwe)' },
      { id: 'sn_ZW', name: 'Shona (Zimbabwe)' },
    ],
    default_locale: 'en_ZW',
  },
  {
    country_code: 'AX',
    locales: [{ id: 'sv', name: 'Swedish' }],
    default_locale: 'sv',
  },
  {
    country_code: 'XK',
    locales: [{ id: 'sq', name: 'Albanian' }],
    default_locale: 'sq',
  },
]



export function getChatWidgetSupportedLocales() {
  return [
    { value: 'location', label: 'Use Location language' },
    { value: 'auto', label: 'Use Website language' },
    { value: 'en-us', label: 'English (United States)' },
    { value: 'en-gb', label: 'English (United Kingdom)' },
    { value: 'de', label: 'German (Germany)' },
    { value: 'fr-fr', label: 'French (France)' },
    { value: 'nl', label: 'Dutch (Netherlands)' },
    { value: 'hu', label: 'Hungarian (Hungary)' },
    { value: 'pt-pt', label: 'Portuguese (Portugal)' },
    { value: 'pt-br', label: 'Portuguese (Brazil)' },
    { value: 'es', label: 'Spanish (Spain)' },
    { value: 'fr-ca', label: 'French (Canada)' },
    { value: 'hr', label: 'Croatian (Croatia)' },
    { value: 'it', label: 'Italian (Italy)' },
    { value: 'sv-se', label: 'Swedish (Sweden)' },
    { value: 'da-dk', label: 'Danish (Denmark)' },
    { value: 'fi', label: 'Finnish (Finland)' },
    { value: 'no', label: 'Norwegian (Norway)' },
  ]
}
